import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Problem } from "@/components/Problem";
import { Solution } from "@/components/Solution";
import { Simulator } from "@/components/Simulator";
import { Benefits } from "@/components/Benefits";
import { Testimonial } from "@/components/Testimonial";
import { Faq } from "@/components/Faq";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const Landing = () => (
    <>
        <Navbar />
        <main>
            <Hero />
            <Problem />
            <Solution />
            <Simulator />
            <Benefits />
            <Testimonial />
            <Faq />
            <FinalCTA />
        </main>
        <Footer />
    </>
);

export default function App() {
    return (
        <div className="min-h-screen bg-[#0B0F17] text-[#F9FAFB]">
            <BrowserRouter>
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/impressum" element={<Impressum />} />
                    <Route path="/datenschutz" element={<Datenschutz />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}
